import React from 'react';
import DashboardCard from './DashboardCard';

const RequestsCard = ({ requests }) => {
    return (
        <DashboardCard
            title="Pending Requests"
            icon="fas fa-hourglass-half"
            action={{ to: '/orders?status=request-pending', label: 'View all requests' }}
        >
            <div className="text-center mb-4">
                <div className="display-4 fw-bold text-warning">{requests?.count || 0}</div>
                <div className="text-light">Awaiting Response</div>
            </div>

            {requests && requests.count > 0 ? (
                <div className="text-center">
                    <div className="alert alert-warning py-2 small">
                        <span className="fas fa-clock me-2" />
                        Action required on {requests.count} request{requests.count !== 1 ? 's' : ''}
                    </div>
                </div>
            ) : (
                <div className="text-center text-light py-4">
                    <span className="fas fa-check-circle fs-3 d-block mb-2 text-success" />
                    All requests processed
                </div>
            )}
        </DashboardCard>
    );
};

export default RequestsCard;
